import { defineStore } from 'pinia';
import subInvoiceApi from '@/api/sub-invoice/index';

//字典查询对象
interface SysMessageInfo {
	messageNotifyItems: IMessageNotifyItem[];
	messageNumber: number|string;
	messageVisible: boolean;
}
export interface IMessageNotifyItem {
	id: number;
	title: string;
	content: string;
	path: string;
}

export const useMessage = defineStore('message', {
	state: (): SysMessageInfo => ({
		messageNotifyItems: [],
		messageNumber: 0,
		// 消息中心是否显示
		messageVisible: false,
	}),
	getters: {
		getMessageItems(): Array<IMessageNotifyItem> {
			return this.messageNotifyItems;
		},
		getMessageItemNumber(): Number {
			return this.messageNotifyItems.length;
		},
	},
	actions: {
		// 添加消息通知
		addMessageItems(data: IMessageNotifyItem) {
			this.messageNotifyItems.unshift(data);
		},
		// 设置未读消息数量
		setMessageNumber() {
			subInvoiceApi.getUnReadCount().then((res: any) => {
				this.messageNumber = res.data;
			});
		},
		// 删除消息通知
		deleteMessageItem(index: number) {
			this.messageNotifyItems.splice(index, 1);
		},
		// 清空消息通知
		clearMessageItems() {
			this.messageNotifyItems = [];
		},
		// 设置消息中心是否显示
		setMessageVisible(data: boolean) {
			this.messageVisible = data;
		},
		// 标记已读
		updateReadStatus(ids: number[], callback?: Function) {
			subInvoiceApi.updateReadStatus({ id: ids }).then((res: any) => {
				if (res && callback) {
					callback();
				}
				this.setMessageNumber();
			});
		},
	},
});
